import React from 'react';
import withData from '@bd/bdcore-data';


function Index() {
  return (
    <div>
      <h2>Comm Plans</h2>
    </div>
  );
}

Index.propTypes = {
};

export default withData({
})(Index);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/Plans/index.js